<template>
    <b-card no-body>

        <b-modal id="update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <mail-integration-update v-model="mailSetting"></mail-integration-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="update"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { SystemParameterApi } from '@/api/system-parameter'
import MailIntegrationUpdate from './components/MailIntegrationUpdate.vue'
export default {
    components:{
        BCard,
        MailIntegrationUpdate
    },
    data(){
        return{
            editing:false,
            loading:false,
            fields:[
                {name:'Mail Adı',key:'MailName',sortable:true, thClass:'w-20'},
                {name:'Mail Adresi',key:'MailAddress',sortable:true, thClass:'w-20'},
                {name:'Host',key:'Host',sortable:true, thClass:'w-20'},
                {name:'Port',key:'Port',sortable:true,thClass:'w-20'},
                {name:'SSL',key:'EnableSSL',sortable:true,thClass:'w-20'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
            ],
            mailSetting:{
                Id:null,
                MailAddress:null,
                Host:null,
                Port:null,
                EnableSSL:false,
                Password:null,
                MailName:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.mailSetting.Id = null
            this.mailSetting.MailAddress = null
            this.mailSetting.Host = null
            this.mailSetting.Port = null
            this.mailSetting.EnableSSL = false
            this.mailSetting.Password = null
            this.mailSetting.MailName = null
        },
        provider(){
            return SystemParameterApi.MailSettingList()
        },
        createNew(){
            this.clearForm()
            this.$showModal('update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.mailSetting.Id = item.Id
            this.mailSetting.MailAddress = item.MailAddress
            this.mailSetting.Host = item.Host
            this.mailSetting.Port = item.Port
            this.mailSetting.EnableSSL = item.EnableSSL
            this.mailSetting.Password = item.Password
            this.mailSetting.MailName = item.MailName
            this.$showModal('update')
        },
        update(){
            this.loading = true
            SystemParameterApi.MailSettingUpdate(this.mailSetting).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('update')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        
    }
}
</script>

<style>

</style>